import {RepeatSettings} from './repeat';

/**
 * A queue that determines when the next instance of a sound is going to play.
 * This is the only class that's allowed to keep state about the state of the looping.
 *  TODO BL: For now we ignore the "times" portion of the RepeatSettings
 */
export class PlayQueue {

    settings: RepeatSettings;
    currentCallback: () => void;
    timeout: NodeJS.Timeout | null;

    private constructor(settings: RepeatSettings) {
        this.settings = settings;
        this.timeout = null;
    }

    public static fromSettings(settings: RepeatSettings): PlayQueue {
        return new PlayQueue(settings);
    }

    public reconfigure(mutator: (RepeatSettings) => RepeatSettings) {
        this.settings = mutator(this.settings);
        // console.log(`BL: Reconfiguring ${this.settings}`);
        if (this.timeout) {
            // console.log(`BL: Timeout is ${this.timeout}, stopping`)
            this.stop();
            this.waitForNext(this.currentCallback)
        }
    }

    public stop() {
        // console.log(`BL: Calling stop ${this.timeout}`);
        clearTimeout(this.timeout);
        this.timeout = null;
    }

    public hasNext(): boolean {
        return this.timeout !== null;
    }

    public waitForNext(andThen: () => void) {
        const nextIn = this.settings.every.getRandom().asMillis();
        this.currentCallback = () => {
            // console.log("BL: Triggering andThen");
            andThen()
            this.stop();
        };
        this.timeout = setTimeout(this.currentCallback, nextIn);
    }
}